export default "__VITE_ASSET__DDiWkR3s__"